import { InfoWindow, Marker } from '@react-google-maps/api';
import {memo,useState,useCallback, useEffect} from 'react'
function MarkerFibraNaps({
    coordenadas,
    item,
    isInCoverage = false,
    ...defaultProps
}) {
    const [isVisible, setIsVisible] = useState(false);
    const [colorIcon, setcolorIcon] = useState('/img/nap-fibra-optica.png')
    useEffect(() => {
        switch (item?.estadoColor || item?.estado) {
            case 'VERDE':
            case 'DISPONIBLE':
            case 'DISPONIBLES':
                setcolorIcon('/img/nap-verde.png')
                break;
            case 'AMARILLO':
                setcolorIcon('/img/nap-amarillo.png')
                break;
            case 'PROYECTADA':
            case 'PROYECTADAS':
                setcolorIcon('/img/nap-gris.png')
                break;
            case 'NARANJA':
                setcolorIcon('/img/nap-naranja.png')
                break;
            case 'NO DISPONIBLE':
            case 'NO DISPONIBLES':
            case 'ROJO':
                setcolorIcon('/img/nap-rojo.png')
                break;
            default:
                setcolorIcon('/img/nap-fibra-optica.png')
                break;
        }
    }, [item])
    
    return (
        <Marker
            {...defaultProps}
            position={coordenadas}
            onClick={()=>setIsVisible(!isVisible)}
            icon={{
                url: colorIcon,
                scaledSize: {
                    width: isInCoverage ? 65 : 50,
                    height: isInCoverage ? 65 : 50,
                }
            }}
            animation={isInCoverage ? window.google?.maps?.Animation?.BOUNCE : null}
            zIndex={isInCoverage ? 1000 : 1}
        >
            { isVisible && (
                <InfoWindow
                    className="card"
                    position={coordenadas}
                    onCloseClick={()=>{setIsVisible(!isVisible)}}
                >
                    <>
                        {isInCoverage && (
                            <div style={{
                                backgroundColor: '#4caf50',
                                color: '#fff',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontWeight: 'bold',
                                fontSize: '11px',
                                textAlign: 'center',
                                marginBottom: '8px'
                            }}>
                                ✓ EN COBERTURA
                            </div>
                        )}
                        <h3 style={{color: '#000',textAlign: 'center'}} >{item?.nombre_fnap || item?.nombre}</h3>
                        <div style={{color: '#000',textAlign: 'center'}}>{`Distancia: ${isInCoverage?.distanciaReal || item?.distanciaReal || item?.distanciaMts || '-'}Mts`}</div>
                        <div style={{color: '#000',textAlign: 'center'}}>{`Ocupados: ${item?.usados}/${item?.puertos}`}</div>
                    </>
                </InfoWindow>
            )}
        </Marker>
    );
}

export default memo(MarkerFibraNaps);
